import './App.css';
import Navbar from './components/Navbar/Navbar';
import Presentation from './components/Presentation/Presentation';
import About from './components/About/About';
import Skills from './components/Skills/Skills';
import Portfolio from './components/Portfolio/Portfolio';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      {/* <Socials /> */}

      <main className="content">
        <Presentation />
        <About />
        <Skills />
        <Portfolio />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}

export default App;
